var gmap;

$(function() {
	$('.single-map').each(function(i, map) {
		initMap(map);
	});
});

function initMap(inputmap) {
	var map = $(inputmap);

	var lat = map.data('lat');
	var lng = map.data('lng');
	var icon = map.attr('data-icon');
	var link = map.attr('data-link');
	var title = map.attr('data-title');

	if (link.length == "") {
		link = "http://maps.google.com/?q=" + lat + "," + lng;
	}

	gmap = new google.maps.Map(inputmap, {
	  zoom: 13,
	  minZoom: 8,
	  center: new google.maps.LatLng(lat, lng),
	  mapTypeControl: false,
	  scrollwheel: false,
	  streetViewControl: false,
	  styles: [{"featureType":"all","elementType":"geometry.fill","stylers":[{"weight":"2.00"}]},{"featureType":"all","elementType":"geometry.stroke","stylers":[{"color":"#9c9c9c"}]},{"featureType":"all","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#eeeeee"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#7b7b7b"}]},{"featureType":"road","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#b4d7f0"},{"visibility":"on"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#b4d7f0"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#070707"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"}]}]
	});

	var marker = new google.maps.Marker({
	  position: new google.maps.LatLng(lat, lng),
	  map: gmap,
	  icon: icon,
	  url: link,
	  title: title
	});

	google.maps.event.addListener(marker, 'click', function() {
		window.open(this.url, '_blank');
	    //window.location.href = this.url;
	});
}


/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/maps/single-map.js
 **/